import { Box } from "@mui/material"
import React from "react"
import {
	ReportAcrissField,
	ReportCategoriesField,
	ReportFuelPolicyField,
	ReportGenerateSwitch,
	ReportLimitHoursField,
	ReportPrepaidField,
	ReportProvidersExclusionSwitch,
	ReportProvidersField,
	ReportWebSuppliersExclusionSwitch,
	ReportWebSuppliersField
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { useSignal } from "@preact/signals-react"
import { reportFormData, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { AppIconChipToggle, AppFormGrid, AppFormSection } from "@components"
import { REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"

export default function ReportFormDrawerExportFiltersSection() {

	const {
		filterProviders,
		filterWebSuppliers,
		idFuelPolicyFilter,
		filterIsPrepaid,
		filterCategories,
		filterAcriss,
		hoursLimit,
		generate
	} = reportFormData.peek()

	const showSection = useSignal(!!(filterProviders?.length || filterWebSuppliers?.length || idFuelPolicyFilter || filterIsPrepaid || filterCategories?.length || filterAcriss?.length || !!hoursLimit || generate))
	const isRating = selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING

	return <AppFormSection
		icon="sliders"
		title="Filters for Excel export & Generation"
		hint="optional"
		data-tour-id="tour-export-filters"
		action={<AppIconChipToggle
			aria-label="Section"
			value={!!showSection.value}
			options={[
				{ value: false, label: 'Hide', icon: 'eye-slash' },
				{ value: true, label: 'Show', icon: 'eye' },
			]}
			onChange={value => showSection.value = value}
		/>}
	>
		{showSection.value && <AppFormGrid>
			<Box sx={{ gridColumn: 'span 6', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
				<ReportProvidersField/>
				<ReportProvidersExclusionSwitch/>
			</Box>
			<Box sx={{ gridColumn: 'span 6', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
				<ReportWebSuppliersField/>
				<ReportWebSuppliersExclusionSwitch/>
			</Box>
			{!isRating && <>
				<Box sx={{ gridColumn: 'span 4' }}>
					<ReportFuelPolicyField/>
				</Box>
				<Box sx={{ gridColumn: 'span 4' }}>
					<ReportPrepaidField/>
				</Box>
				<Box sx={{ gridColumn: 'span 4' }}>
					<ReportCategoriesField/>
				</Box>
				<Box sx={{ gridColumn: 'span 4' }}>
					<ReportAcrissField/>
				</Box>
				<Box sx={{ gridColumn: 'span 4' }}>
					<ReportLimitHoursField/>
				</Box>
				<Box sx={{ gridColumn: 'span 4', display: 'flex', alignItems: 'center', minHeight: 44 }}>
					<ReportGenerateSwitch/>
				</Box>
			</>}
		</AppFormGrid>}
	</AppFormSection>
}
